var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentGateway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6595 21.6719C28.6595 20.2451 29.8162 19.0885 31.243 19.0885H35.5487C36.0243 19.0885 36.4099 19.474 36.4099 19.9496V23.3943C36.4099 23.8699 36.0243 24.2554 35.5487 24.2554H31.243C29.8162 24.2554 28.6595 23.0988 28.6595 21.6719Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.72231
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9616 12.1992H7.12692C6.65132 12.1992 6.26577 12.5848 6.26577 13.0604V19.9505H4.54368V30.3177C4.54353 30.3063 4.54346 30.2949 4.54346 30.2835V13.0604C4.54346 11.6336 5.70011 10.4769 7.12692 10.4769H32.9616C34.3884 10.4769 35.5451 11.6336 35.5451 13.0604V19.0885H33.8227V13.0604C33.8227 12.5848 33.4372 12.1992 32.9616 12.1992ZM15.5239 32.8669L32.9616 32.8669C34.3884 32.8669 35.5451 31.7103 35.5451 30.2835V25.1166H33.8227V30.2835C33.8227 30.7591 33.4372 31.1446 32.9616 31.1446H15.5239V32.8669Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12695 11.3339L21.5476 5.77144C24.012 4.86477 25.8915 5.33216 26.0724 6.90262V11.3406",
    stroke: "#2E2E2E",
    strokeWidth: 1.72231,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0001,
    cy: 26.3636,
    r: 8.18182,
    stroke: "currentColor",
    strokeWidth: 1.81818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 21.8182V30.9091M12.841 23.1759H9.12596C8.60434 23.1759 8.10408 23.3438 7.73524 23.6427C7.36639 23.9416 7.15918 24.3471 7.15918 24.7698C7.15918 25.1925 7.36639 25.5979 7.73524 25.8968C8.10408 26.1957 8.60434 26.3636 9.12596 26.3636H10.8742C11.1325 26.3636 11.3882 26.4049 11.6269 26.485C11.8655 26.5651 12.0823 26.6825 12.2649 26.8305C12.4476 26.9785 12.5924 27.1542 12.6913 27.3475C12.7901 27.5409 12.841 27.7482 12.841 27.9575C12.841 28.1668 12.7901 28.3741 12.6913 28.5674C12.5924 28.7608 12.4476 28.9365 12.2649 29.0845C12.0823 29.2325 11.8655 29.3499 11.6269 29.43C11.3882 29.5101 11.1325 29.5514 10.8742 29.5514H7.15918",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentGateway);
export default __webpack_public_path__ + "static/media/Payment Gateway.a2b52a401fd8ec945b02aa427bd8dabd.svg";
export { ForwardRef as ReactComponent };